import(/* webpackMode: "eager" */ "/vercel/path0/app/impact/page.tsx");
